export const companyPublicFormStyles = (theme) => ({
  uploadBox: {
    backgroundColor: theme.palette.grey[100],
    border: `1px dashed ${theme.palette.grey[400]}`,
    borderRadius: 4,
    textAlign: 'center',
    padding: 20,
  },
})
